export default function Forbidden() {
  return (
    <div className="text-center h-[100vh] flex align-center flex-col justify-center">
      <h1>403 – Access Denied</h1>
      <p>You don’t have permission to view this page.</p>
    </div>
  );
}
